import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: "https://2e5df1bf375ed29dbe5ac2d8d3d27bef@o4507855621259264.ingest.us.sentry.io/4507935911247872",
    environment: process.env.NODE_ENV,
  });
}

export default Sentry;